import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useDocTransmittalContext } from "../DocTransmittal.context";

export default function ReceiverRadioBtns() {
  const { newDoc, setNewDoc } = useDocTransmittalContext();

  const handleChange = (event) => {
    setNewDoc({ ...newDoc, receiverType: event.target.value });
  };

  return (
    <FormControl sx={{ pr: 2, mr: 2, borderRight: "1px solid #ccc" }}>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={newDoc.receiverType}
        onChange={handleChange}
      >
        <FormControlLabel value="Client" control={<Radio />} label="Client" />
        <FormControlLabel value="Vendor" control={<Radio />} label="Vendor" />
      </RadioGroup>
    </FormControl>
  );
}
